<div class="box-form-ui container economic-activity">
  <h1>¿A qué te dedicas?</h1>
  <form
    id="FormEconomicActivity"
    class="form-economic-activity"
    [formGroup]="economicActivityForm"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
  >
    <mat-radio-group
      class="radio-group-economic-activity"
      formControlName="economicActivity"
    >
      <mat-radio-button
        *ngFor="let radio of radioGroup"
        class="radio-button-economic-activity"
        [value]="radio.value"
        ><span>{{ radio.text }}</span>
        <em [className]="'icon ' + radio.iconClass"></em
      ></mat-radio-button>
    </mat-radio-group>

    <div
      class="container-autocomplete-economic-activity"
      *ngIf="controlCodeCIIU.enabled"
    >
      <p class="copy-ciiu">
        Ingresa el código CIIU y/o la descripción de tu actividad económica
      </p>
      <mat-form-field appearance="fill" class="field-economic-activity">
        <mat-label class="label"> Código CIIU </mat-label>
        <input
          matInput
          type="text"
          formControlName="codeCIIU"
          [matAutocomplete]="auto"
          maxlength="150"
          id="CIIUCode"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          class="autocomplete-ciiu-code"
          [displayWith]="displayFn"
          (closed)="closedEmitter()"
        >
          <mat-option
            *ngFor="let option of filteredOptions | async"
            class="option-ciiu-code"
            [value]="option"
          >
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>

        <mat-error
          *ngIf="economicActivityForm.controls.codeCIIU.hasError('required')"
        >
          Este campo es obligatorio
        </mat-error>
        <mat-error
          *ngIf="
            !economicActivityForm.controls.codeCIIU.hasError('required') &&
            economicActivityForm.controls.codeCIIU.hasError('isString')
          "
        >
          La actividad económica ingresada no es válida
        </mat-error>
      </mat-form-field>
    </div>

    <div class="box-btn-submit">
      <button
        class="btn btn-degraded blue"
        type="submit"
        [disabled]="!economicActivityForm.valid"
        id="SubmitEconomicActivityForm"
      >
        Continuar
      </button>
    </div>
  </form>
</div>
